<div class="card">
  <div class="card-header">
    <app-report-filter [fg]="fg" (submit)="onSubmit($event)"></app-report-filter>
  </div>
  <div class="card-body">
    <app-acc-loader *ngIf="waitHandler.processing"></app-acc-loader>
    <ng-container *ngIf="!waitHandler.processing">
      <app-acc-barchart *ngIf="properties$|async as properties" [properties]="properties"></app-acc-barchart>
    </ng-container>
  </div>
  <div class="card-footer"></div>
</div>